<template>
  <span class="tag" :class="badgeClass">
    <slot name="default" />
  </span>
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue';

type BadgeType = 'disabled' | 'danger' | 'warning' | 'info' | 'link' | 'primary' | 'success';
type BadgeSize = 'small' | 'medium' | 'large';

const props = defineProps({
  type: {
    type: String as PropType<BadgeType>,
  },
  size: {
    type: String as PropType<BadgeSize>,
    default: 'small',
  },
});

const badgeClass = computed(() => `${badgeTypeClass.value} ${badgeSizeClass.value}`);
const badgeTypeClass = computed(() => 'is-' + (props.type ? props.type : 'disabled'));
const badgeSizeClass = computed(() => {
  if (props.size === 'large') {
    return 'large-tag';
  } else if (props.size === 'medium') {
    return 'medium-tag';
  } else {
    return 'small-tag';
  }
});
</script>

<style scoped>
.small-tag {
  font-size: 0.75em;
}
.medium-tag {
  font-size: 0.9em;
}
.large-tag {
  font-size: 1.1em;
}
</style>
